"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usageTrackerMiddleware;

var _Constants = require("FileManagerCore/Constants");

function usageTrackerJsEventHandling(_ref) {
  var Tracker = _ref.Tracker,
      name = _ref.name,
      eventPayload = _ref.eventPayload;

  if (name) {
    Tracker.track(name, eventPayload);
  }
}

function hublyticsEventHandling(_ref2) {
  var Tracker = _ref2.Tracker,
      name = _ref2.name,
      type = _ref2.type,
      eventPayload = _ref2.eventPayload,
      options = _ref2.options;

  switch (type) {
    case _Constants.TrackEventTypes.USAGE:
      Tracker.trackUsage(name, eventPayload, options);
      break;

    case _Constants.TrackEventTypes.ERROR:
      Tracker.trackError(name, eventPayload, options);
      break;

    case _Constants.TrackEventTypes.INTERACTION:
    default:
      Tracker.trackInteraction(name, eventPayload, options);
  }
}

function usageTrackerMiddleware(Tracker, getEventPayload, options) {
  return function () {
    return function (next) {
      return function (action) {
        if (!Tracker || !action.meta || !action.meta[_Constants.TRACK_EVENT]) {
          return next(action);
        }

        var _action$meta$TRACK_EV = action.meta[_Constants.TRACK_EVENT],
            name = _action$meta$TRACK_EV.name,
            usageTrackerJsName = _action$meta$TRACK_EV.usageTrackerJsName,
            eventAction = _action$meta$TRACK_EV.action,
            type = _action$meta$TRACK_EV.type,
            meta = _action$meta$TRACK_EV.meta;
        var eventPayload = getEventPayload(eventAction, meta);

        if (!Tracker.trackInteraction) {
          usageTrackerJsEventHandling({
            Tracker: Tracker,
            name: usageTrackerJsName,
            eventPayload: eventPayload
          });
        } else {
          hublyticsEventHandling({
            Tracker: Tracker,
            name: name,
            type: type,
            eventPayload: eventPayload,
            options: options
          });
        }

        return next(action);
      };
    };
  };
}

module.exports = exports.default;